import { render, staticRenderFns } from "./adminArea.vue?vue&type=template&id=ad2ac412&scoped=true"
import script from "./adminArea.vue?vue&type=script&lang=js"
export * from "./adminArea.vue?vue&type=script&lang=js"
import style0 from "./adminArea.vue?vue&type=style&index=0&id=ad2ac412&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad2ac412",
  null
  
)

export default component.exports